import { render, staticRenderFns } from "./SideWindowContainer.vue?vue&type=template&id=60110ff1&scoped=true&"
import script from "./SideWindowContainer.vue?vue&type=script&lang=js&"
export * from "./SideWindowContainer.vue?vue&type=script&lang=js&"
import style0 from "./SideWindowContainer.vue?vue&type=style&index=0&id=60110ff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60110ff1",
  null
  
)

export default component.exports